import type { UIViewController } from "uicore-ts"


/** The localization key a view controller declares for the top bar title, if it declares one. */
export function titleKeyOfViewController(viewController: UIViewController | undefined): string | undefined {
    if (viewController && "titleKey" in viewController && typeof viewController.titleKey === "string") {
        return viewController.titleKey
    }
    return undefined
}
